export default "__VITE_ASSET__BhO46GGF__"